import Cadastro from './Cadastro.vue';
import PainelTV from './PainelTV.vue';
import Atendente from './Atendente.vue';

const routes = [
    {
        path: '/checkins/guiche/cadastro',
        name: 'GuicheCadastro',
        component: Cadastro,
        meta: { rules: ['CHECKINS-GUICHE-01'] },
    },
    {
        path: '/checkins/guiche/painel-tv',
        name: 'GuichePainelTV',
        component: PainelTV,
    },
    {
        path: '/checkins/guiche/atendente',
        name: 'GuicheAtendente',
        component: Atendente,
    },
];

export default routes;
